import React from 'react'

function LabLayout() {
  return (
    <div>LabLayout</div>
  )
}

export default LabLayout